import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/index'
import MaterialManageRoutes from './material-manage'
import otherRouter from './other'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/customerManage/customerSatisfactionEdit',
      name: 'customerSatisfactionEdit',
      meta: {
        title: '编辑客户满意度',
        keepAlive: false
      },
      component: resolve =>
        require([
          '@/views/corp/customerManage/satisfaction/customerSatisfactionEdit.vue'
        ], resolve)
    },
    {
      path: '/mobile/login',
      name: 'mobileLogin',
      component: resolve => require(['@/views/mobile/mobileLogin.vue'], resolve)
    },
    {
      path: '/mobile/statistic/indexReportFormData',
      name: 'indexReportFormData',
      component: resolve =>
        require(['@/views/mobile/statistic/indexReportFormData.vue'], resolve)
    },
    {
      path: '/wechat/auth',
      name: 'wxMessageRoute',
      component: resolve =>
        require(['@/views/mobile/wxMessageRoute.vue'], resolve)
    },
    {
      path: '/dingTalk/auth',
      name: 'ddMessageRoute',
      component: resolve =>
        require(['@/views/mobile/ddMessageRoute.vue'], resolve)
    },
    {
      path: '/mobile/dingLogin',
      name: 'mobileDingLogin',
      component: resolve =>
        require(['@/views/mobile/dingMobileLogin.vue'], resolve)
    },
    {
      path: '/mobile',
      component: resolve =>
        require(['@/views/mobile/mobileIndex.vue'], resolve),
      children: [
        {
          path: 'home',
          name: 'mobileHome',
          component: resolve => require(['@/views/mobile/home.vue'], resolve)
        },
        {
          path: 'message',
          name: 'mobileMessage',
          component: resolve =>
            require(['@/views/mobile/mobileMessage.vue'], resolve)
        },
        {
          path: 'set',
          name: 'mobileSet',
          component: resolve =>
            require(['@/views/mobile/mobileSet.vue'], resolve)
        }
      ]
    },
    {
      path: '/mobile/knowledgeIndex',
      name: 'mobileKnowledgeIndex',
      component: resolve =>
        require(['@/views/mobile/knowledge/knowledgeIndex.vue'], resolve)
    },
    {
      path: '/mobile/knowledgeView/:id',
      name: 'knowledgeView',
      component: resolve =>
        require(['@/views/mobile/knowledge/knowledgeView.vue'], resolve)
    },
    {
      path: '/mobile/fileView',
      name: 'mobileFileView',
      component: resolve =>
        require(['@/views/mobile/knowledge/fileView.vue'], resolve)
    },
    {
      path: '/mobile/equipmentIndex',
      name: 'mobileEquipmentIndex',
      component: resolve =>
        require(['@/views/mobile/equipment/equipmentIndex.vue'], resolve)
    },
    {
      path: '/mobile/mobileCustomerSatisfaction',
      name: 'mobileCustomerSatisfaction',
      component: resolve =>
        require([
          '@/views/mobile/satisfaction/mobileCustomerSatisfaction.vue'
        ], resolve)
    },
    {
      path: '/mobile/mobileCustomerSatisfactionAdd',
      name: 'mobileCustomerSatisfactionAdd',
      component: resolve =>
        require([
          '@/views/mobile/satisfaction/mobileCustomerSatisfactionAdd.vue'
        ], resolve)
    },
    {
      path: '/mobile/mobileCustomerSatisfactionEdit',
      name: 'mobileCustomerSatisfactionEdit',
      component: resolve =>
        require([
          '@/views/mobile/satisfaction/mobileCustomerSatisfactionEdit.vue'
        ], resolve)
    },
    {
      path: '/mobile/mobileCustomerSatisfactionDetail',
      name: 'mobileCustomerSatisfactionDetail',
      component: resolve =>
        require([
          '@/views/mobile/satisfaction/mobileCustomerSatisfactionDetail.vue'
        ], resolve)
    },
    {
      path: '/mobile/equipmentView/:id',
      name: 'equipmentView',
      component: resolve =>
        require(['@/views/mobile/equipment/equipmentView.vue'], resolve)
    },
    {
      path: '/mobile/equipmentCanvas/:id',
      name: 'equipmentCanvas',
      component: resolve =>
        require(['@/views/mobile/equipment/equipmentCanvas.vue'], resolve)
    },
    {
      path: '/mobile/equipmentDetail/:id',
      name: 'equipmentDetail',
      component: resolve =>
        require(['@/views/mobile/equipment/equipmentDetail.vue'], resolve)
    },
    //设备铭牌信息
    {
      path: '/mobile/equipmentInformation/:id',
      name: 'equipmentInformation',
      component: resolve =>
        require(['@/views/mobile/equipment/equipmentInformation.vue'], resolve)
    },
    {
      path: '/mobile/mobileLogisticsInfo',
      name: 'mobileLogisticsInfo',
      component: resolve =>
        require(['@/views/mobile/repair/mobileLogisticsInfo.vue'], resolve)
    },
    {
      path: '/mobile/repairIndex',
      name: 'mobileRepairIndex',
      component: resolve =>
        require(['@/views/mobile/repair/mobileRepairIndex.vue'], resolve)
    },
    {
      path: '/mobile/addRepair',
      name: 'mobileAddRepair',
      component: resolve =>
        require(['@/views/mobile/repair/mobileAddRepair.vue'], resolve)
    },
    {
      path: '/mobile/editRepair',
      name: 'mobileEditRepair',
      component: resolve =>
        require(['@/views/mobile/repair/mobileEditRepair.vue'], resolve)
    },
    {
      path: '/mobile/viewRepair',
      name: 'mobileViewRepair',
      component: resolve =>
        require(['@/views/mobile/repair/mobileViewRepair.vue'], resolve)
    },
    {
      path: '/mobile/repairCustomerIndex',
      name: 'mobileRepairCustomerIndex',
      component: resolve =>
        require(['@/views/mobile/repairCustomer/mobileRepairCustomerIndex.vue'], resolve)
    },
    {
      path: '/mobile/mobileAfterSaleChatLLM',
      name: 'mobileAfterSaleChatLLM',
      component: resolve =>
        require(['@/views/mobile/repairCustomer/mobileAfterSaleChatLLM.vue'], resolve)
    },
    {
      path: '/mobile/repairCustomerList',
      name: 'mobileRepairCustomerList',
      component: resolve =>
        require(['@/views/mobile/repairCustomer/mobileRepairCustomerList.vue'], resolve)
    },
    {
      path: '/mobile/addRepairCustomer',
      name: 'mobileAddRepairCustomer',
      component: resolve =>
        require(['@/views/mobile/repairCustomer/mobileAddRepairCustomer.vue'], resolve)
    },
    {
      path: '/mobile/viewAndEditRepairCustomer',
      name: 'mobileViewAndEditRepairCustomer',
      component: resolve =>
        require(['@/views/mobile/repairCustomer/mobileViewAndEditRepairCustomer.vue'], resolve)
    },
    {
      path: '/mobile/checkIndex',
      name: 'mobileCheckIndex',
      component: resolve =>
        require(['@/views/mobile/checkRecord/mobileCheckIndex.vue'], resolve)
    },
    {
      path: '/mobile/mobileViewCheck/:id',
      name: 'mobileViewCheck',
      component: resolve =>
        require(['@/views/mobile/checkRecord/mobileViewCheck.vue'], resolve)
    },
    {
      path: '/mobile/addCheck',
      name: 'mobileAddCheck',
      component: resolve =>
        require(['@/views/mobile/checkRecord/mobileAddCheck.vue'], resolve)
    },
    {
      path: '/mobile/inspectionIndex',
      name: 'mobileInspectionIndex',
      component: resolve =>
        require([
          '@/views/mobile/inspectionRecord/mobileInspectionIndex.vue'
        ], resolve)
    },
    {
      path: '/mobile/inspectionView/:id',
      name: 'mobileViewInspection',
      component: resolve =>
        require([
          '@/views/mobile/inspectionRecord/mobileViewInspection.vue'
        ], resolve)
    },
    {
      path: '/mobile/addInspection',
      name: 'mobileAddInspection',
      component: resolve =>
        require([
          '@/views/mobile/inspectionRecord/mobileAddInspection.vue'
        ], resolve)
    },
    // 异常事件消息详情
    {
      path: '/mobile/errorMessageDetail',
      name: 'errorMessageDetail',
      // component: resolve =>
      //   require(["@/views/mobile/errorMessageDetail/index.vue"], resolve)
      component: () =>
        import(
          /* webpackChunkName: "factoryConfig" */ '../views/mobile/errorMessageDetail/index.vue'
          )
    },
    {
      path: '/mobile/signExample',
      name: 'signExample',
      component: resolve => require(['@/views/mobile/signExample.vue'], resolve)
    },
    {
      path: '/mobile/workOrderIndex',
      name: 'mobileOrderIndex',
      component: resolve =>
        require(['@/views/mobile/workOrder/mobileOrderIndex.vue'], resolve)
    },
    {
      path: '/mobile/orderView/:id',
      name: 'mobileViewOrder',
      component: resolve =>
        require(['@/views/mobile/workOrder/mobileViewOrder.vue'], resolve)
    },
    {
      path: '/mobile/approval/add/:id(\\d+)',
      props: true,
      component: () => import('@/_mobile/views/approval/add')
    },
    {
      path: '/mobile/approval/detail/:id(\\d+)',
      props: true,
      component: () => import('@/_mobile/views/approval/detail')
    },
    {
      path: '/mobile/approval/approvalList',
      name: 'mobileApprovalList',
      component: resolve =>
        require(['@/views/mobile/approval/approvalList.vue'], resolve)
    },
    {
      path: '/mobile/materialManage/materialIndex',
      name: 'mobileMaterialIndex',
      component: resolve =>
        require(['@/views/mobile/materialManage/materialIndex.vue'], resolve)
    },
    {
      path: '/mobile/materialManage/materialView',
      name: 'mobileMaterialView',
      component: resolve =>
        require(['@/views/mobile/materialManage/materialView.vue'], resolve)
    },
    {
      path: '/mobile/statistic/statisticTypeList',
      name: 'statisticTypeList',
      component: resolve =>
        require(['@/views/mobile/statistic/statisticTypeList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/waterStatisticList',
      name: 'waterStatisticList',
      component: resolve =>
        require(['@/views/mobile/statistic/waterStatisticList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/addWater',
      name: 'addWater',
      component: resolve =>
        require(['@/views/mobile/statistic/addWater.vue'], resolve)
    },
    {
      path: '/mobile/statistic/editWater',
      name: 'editWater',
      component: resolve =>
        require(['@/views/mobile/statistic/editWater.vue'], resolve)
    },
    {
      path: '/mobile/statistic/electStatisticList',
      name: 'electStatisticList',
      component: resolve =>
        require(['@/views/mobile/statistic/electStatisticList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/addElect',
      name: 'addElect',
      component: resolve =>
        require(['@/views/mobile/statistic/addElect.vue'], resolve)
    },
    {
      path: '/mobile/statistic/editElect',
      name: 'editElect',
      component: resolve =>
        require(['@/views/mobile/statistic/editElect.vue'], resolve)
    },
    {
      path: '/mobile/statistic/sulphateOutList',
      name: 'sulphateOutList',
      component: resolve =>
        require([
          '@/views/mobile/statistic/sulphateOutStatisticList.vue'
        ], resolve)
    },
    {
      path: '/mobile/statistic/sulphateOutAdd',
      name: 'sulphateOutAdd',
      component: resolve =>
        require(['@/views/mobile/statistic/sulphateOutAdd.vue'], resolve)
    },
    {
      path: '/mobile/statistic/sulphateOutEdit',
      name: 'sulphateOutEdit',
      component: resolve =>
        require(['@/views/mobile/statistic/sulphateOutEdit.vue'], resolve)
    },
    {
      path: '/mobile/statistic/sulphateStorageList',
      name: 'sulphateStorageList',
      component: resolve =>
        require(['@/views/mobile/statistic/sulphateStorageList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/sulphateStorageAdd',
      name: 'sulphateStorageAdd',
      component: resolve =>
        require(['@/views/mobile/statistic/sulphateStorageAdd.vue'], resolve)
    },
    {
      path: '/mobile/statistic/sulphateStorageEdit',
      name: 'sulphateStorageEdit',
      component: resolve =>
        require(['@/views/mobile/statistic/sulphateStorageEdit.vue'], resolve)
    },
    {
      path: '/mobile/statistic/materialList',
      name: 'materialList',
      component: resolve =>
        require(['@/views/mobile/statistic/materialList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/materialAdd',
      name: 'materialAdd',
      component: resolve =>
        require(['@/views/mobile/statistic/materialAdd.vue'], resolve)
    },
    {
      path: '/mobile/statistic/materialEdit',
      name: 'materialEdit',
      component: resolve =>
        require(['@/views/mobile/statistic/materialEdit.vue'], resolve)
    },
    {
      path: '/mobile/statistic/materialManager/materialStatisticIndex',
      name: 'materialStatisticIndex',
      component: resolve =>
        require([
          '@/views/mobile/statistic/materialManager/materialStatisticIndex.vue'
        ], resolve)
    },
    {
      path: '/mobile/statistic/materialManager/materialInventoryIndex',
      name: 'materialInventoryIndex',
      component: resolve =>
        require([
          '@/views/mobile/statistic/materialManager/materialInventoryIndex.vue'
        ], resolve)
    },
    {
      path: '/mobile/statistic/materialManager/materialOutAndInRecord',
      name: 'materialOutAndInRecord',
      component: resolve =>
        require([
          '@/views/mobile/statistic/materialManager/materialOutAndInRecord.vue'
        ], resolve)
    },
    {
      path: '/mobile/statistic/materialManager/materialOutAndIn',
      name: 'materialOutAndIn',
      component: resolve =>
        require([
          '@/views/mobile/statistic/materialManager/materialOutAndIn.vue'
        ], resolve)
    },
    {
      path: '/mobile/statistic/brokenRecordList',
      name: 'brokenRecordList',
      component: resolve =>
        require(['@/views/mobile/statistic/brokenRecordList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/brokenRecordAdd',
      name: 'brokenRecordAdd',
      component: resolve =>
        require(['@/views/mobile/statistic/brokenRecordAdd.vue'], resolve)
    },
    {
      path: '/mobile/statistic/brokenRecordEdit',
      name: 'brokenRecordEdit',
      component: resolve =>
        require(['@/views/mobile/statistic/brokenRecordEdit.vue'], resolve)
    },
    {
      path: '/mobile/statistic/downtimeList',
      name: 'downtimeList',
      component: resolve =>
        require(['@/views/mobile/statistic/downtimeList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/downtimeAdd',
      name: 'downtimeAdd',
      component: resolve =>
        require(['@/views/mobile/statistic/downtimeAdd.vue'], resolve)
    },
    {
      path: '/mobile/statistic/downtimeEdit',
      name: 'downtimeEdit',
      component: resolve =>
        require(['@/views/mobile/statistic/downtimeEdit.vue'], resolve)
    },
    {
      path: '/mobile/statistic/waterSummaryList',
      name: 'waterSummaryList',
      component: resolve =>
        require(['@/views/mobile/statistic/waterSummaryList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/electElectricityList',
      name: 'electElectricityList',
      component: resolve =>
        require(['@/views/mobile/statistic/electElectricityList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/sulphateOutSummaryList',
      name: 'sulphateOutSummaryList',
      component: resolve =>
        require([
          '@/views/mobile/statistic/sulphateOutSummaryList.vue'
        ], resolve)
    },
    {
      path: '/mobile/statistic/sulphateSummaryList',
      name: 'sulphateSummaryList',
      component: resolve =>
        require(['@/views/mobile/statistic/sulphateSummaryList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/materialSummaryList',
      name: 'materialSummaryList',
      component: resolve =>
        require(['@/views/mobile/statistic/materialSummaryList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/brokenSummaryList',
      name: 'brokenSummaryList',
      component: resolve =>
        require(['@/views/mobile/statistic/brokenSummaryList.vue'], resolve)
    },
    {
      path: '/mobile/statistic/downtimeSummaryList',
      name: 'downtimeSummaryList',
      component: resolve =>
        require(['@/views/mobile/statistic/downtimeSummaryList.vue'], resolve)
    },
    //故障查询
    {
      path: '/mobile/troubleshoot/index',
      name: 'troubleshootIndex',
      meta: {
        title: '故障查询',
        keepAlive: false
      },
      component: resolve =>
        require(['@/views/mobile/troubleshoot/index.vue'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login.vue'], resolve)
    },
    {
      path: '/equipmentCenter/workShop',
      name: 'workShop',
      meta: {
        title: '组态设计',
        keepAlive: false
      },
      component: resolve =>
        require([
          '@/views/corp/equipmentCenter/templateManage/workShop.vue'
        ], resolve)
    },
    {
      path: '/equipmentCenter/previewWorkShop',
      name: 'previewWorkShop',
      meta: {
        title: '组态预览',
        keepAlive: false
      },
      component: resolve =>
        require([
          '@/views/corp/equipmentCenter/templateManage/previewWorkShop.vue'
        ], resolve)
    },
    {
      path: '/equipmentCenter/datatableConfig',
      name: 'datatableConfig',
      meta: {
        title: '数据源配置',
        keepAlive: false
      },
      component: resolve =>
        require([
          '@/views/corp/equipmentCenter/templateManage/datatableConfig.vue'
        ], resolve)
    },
    {
      path: '/equipmentCenter/dataSourceConfig',
      name: 'dataSourceConfig',
      meta: {
        title: '数据源配置',
        keepAlive: false
      },
      component: resolve =>
        require([
          '@/views/corp/equipmentCenter/templateManage/dataSourceConfig.vue'
        ], resolve)
    },
    {
      path: '/equipmentCenter/topologySet',
      name: 'topologySet',
      meta: {
        title: '组态设置',
        keepAlive: false
      },
      component: resolve =>
        require([
          '@/views/corp/equipmentCenter/templateManage/topologySet.vue'
        ], resolve)
    },
    {
      path: '/approval/designCenterFrom',
      name: 'designCenterFrom',
      meta: {
        title: '审批基础设置',
        keepAlive: false
      },
      component: resolve =>
        require(['@/views/corp/approval/designCenterFrom.vue'], resolve)
    },
    {
      path: '/approval/editDesignCenterFrom/:id',
      name: 'editDesignCenterFrom',
      meta: {
        title: '编辑审批基础设置',
        keepAlive: false,
        edit: true
      },
      component: resolve =>
        require(['@/views/corp/approval/designCenterFrom.vue'], resolve)
    },
    {
      path: '/approval/dynamicForm/:id',
      name: 'DynamicForm',
      meta: {
        title: '审批表单设置',
        keepAlive: false
      },
      component: resolve =>
        require(['@/views/corp/approval/dynamicForm.vue'], resolve)
    },
    {
      path: '/approval/Process/:id',
      name: 'Process',
      meta: {
        title: '审批流程设计',
        keepAlive: false
      },
      component: resolve =>
        require(['@/views/corp/approval/Process.vue'], resolve)
    },
    // 打印
    {
      path: '/repairManage/repairExport',
      name: 'repairExport',
      meta: {
        title: '报修单导出',
        keepAlive: false
      },
      component: resolve =>
        require([
          '@/views/corp/afterSaleManage/repairManage/repairExport.vue'
        ], resolve)
    },
    {
      path: '/checkRecordManage/checkRecordExport',
      name: 'checkRecordExport',
      meta: {
        title: '点检单导出',
        keepAlive: false
      },
      component: resolve =>
        require([
          '@/views/corp/afterSaleManage/checkRecordManage/checkRecordExport.vue'
        ], resolve)
    },
    {
      path: '/inspectionRecordManage/inspectionRecordExport',
      name: 'inspectionRecordExport',
      meta: {
        title: '巡检单导出',
        keepAlive: false
      },
      component: resolve =>
        require([
          '@/views/corp/afterSaleManage/inspectionRecordManage/inspectionRecordExport.vue'
        ], resolve)
    },
    {
      path: '/purchase-receive/receiveRecordExport',
      meta: {title: '打印收货单'},
      component: resolve =>
        require([
          '@/views/corp/materialManage/purchase-receive/receiveRecordExport.vue'
        ], resolve)
    },
    {
      path: '/',
      component: resolve => require(['@/views/index.vue'], resolve),
      children: [
        {
          path: '/',
          name: '',
          meta: {
            title: '首页',
            keepAlive: true
          },
          component: resolve => require(['@/views/template.vue'], resolve)
        },
        {
          path: '/knowledgeManage/knowledgeIndex',
          name: 'knowledgeIndex',
          meta: {
            title: '知识管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/knowledgeManage/knowledgeIndex.vue'
            ], resolve)
        },
        {
          path: '/knowledgeManage/addKnowledge',
          name: 'addKnowledge',
          meta: {
            title: '添加知识点',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/knowledgeManage/addKnowledge.vue'], resolve)
        },
        {
          path: '/knowledgeManage/editKnowledge',
          name: 'editKnowledge',
          meta: {
            title: '编辑知识点',
            editType: true,
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/knowledgeManage/editKnowledge.vue'], resolve)
        },
        {
          path: '/knowledgeManage/viewKnowledge',
          name: 'viewKnowledge',
          meta: {
            title: '知识点预览',
            editType: true,
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/knowledgeManage/viewKnowledge.vue'], resolve)
        },
        {
          path: '/knowledgeManage/previewKnowledge/:id',
          name: 'previewKnowledge',
          meta: {
            title: '附件预览',
            editType: true,
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/knowledgeManage/previewKnowledge.vue'
            ], resolve)
        },
        {
          path: '/equipmentCenter/equipmentDashboard',
          name: 'equipmentDashboard',
          meta: {
            title: '设备仪表盘',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/equipmentDashboardManage/equipmentDashboard1.vue'
            ], resolve)
        },
        {
          path: '/equipmentCenter/equipmentDashboardDetail',
          name: 'equipmentDashboardDetail',
          meta: {
            title: '编辑设备仪表盘',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/equipmentDashboardManage/equipmentDashboardDetail.vue'
            ], resolve)
        },
        {
          path: '/equipmentCenter/equipmentTemplateIndex',
          name: 'equipmentTemplateIndex',
          meta: {
            title: '设备模版',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/equipmentTemplate/equipmentTemplateIndex.vue'
            ], resolve)
        },
        {
          path: '/equipmentCenter/equipmentGrouping',
          name: 'equipmentGrouping',
          meta: {
            title: '设备分组',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/equipmentGrouping/equipmentGroupingIndex.vue'
            ], resolve)
        },
        {
          path: '/equipmentCenter/equipmentIndex',
          name: 'equipmentIndex',
          meta: {
            title: '设备管理',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/equipmentManage/equipmentIndex.vue'
            ], resolve)
        },
        {
          path: '/equipmentCenter/addEquipment',
          name: 'addEquipment',
          meta: {
            title: '添加设备',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/equipmentManage/equipmentConfig.vue'
            ], resolve)
        },
        
        {
          path: "/equipmentCenter/equipmentDiagnoseIndex",
          name: "equipmentDiagnoseIndex",
          meta: {
            title: "设备诊断",
            keepAlive: true
          },
          component: resolve =>
            require([
              "@/views/corp/equipmentCenter/equipmentDiagnose/equipmentDiagnoseIndex.vue"
            ], resolve)
        },
        {
          path: "/equipmentCenter/equipmentPresent",
          name: "equipmentPresent",
          meta: {
            title: "设备现状",
            keepAlive: true
          },
          component: resolve =>
            require([
              "@/views/corp/equipmentCenter/equipmentDiagnose/equipmentPresent.vue"
            ], resolve)
        },
        {
          path: "/equipmentCenter/equipmentMonitor",
          name: "equipmentMonitor",
          meta: {
            title: "标准监测",
            keepAlive: true
          },
          component: resolve =>
            require([
              "@/views/corp/equipmentCenter/equipmentDiagnose/equipmentMonitor.vue"
            ], resolve)
        },
        {
          path: "/equipmentCenter/patrolAnalysisReports",
          name: "patrolAnalysisReports",
          meta: {
            title: "设备故障诊断",
            keepAlive: true
          },
          component: resolve =>
            require([
              "@/views/corp/equipmentCenter/patrolAnalysisReports/patrolAnalysisReportIndex.vue"
            ], resolve)
        },
        {
          path: '/equipmentCenter/copyEquipment',
          name: 'copyEquipment',
          meta: {
            title: '复制设备',
            keepAlive: false,
            isCopy: true
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/equipmentManage/equipmentConfig.vue'
            ], resolve)
        },
        {
          path: '/equipmentCenter/editEquipment',
          name: 'editEquipment',
          meta: {
            title: '编辑设备',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/equipmentManage/editEquipmentConfig.vue'
            ], resolve)
        },
        {
          path: '/equipmentCenter/equipmentView',
          name: 'configView',
          meta: {
            title: '设备详情',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/equipmentManage/equipmentView.vue'
            ], resolve)
        },

        {
          path: '/warnManage/warnIndex',
          name: 'warnIndex',
          meta: {
            title: '告警列表',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/warnManage/warnIndex.vue'
            ], resolve)
        },
        {
          path: '/gatewaySettingManage/gatewayIndex',
          name: 'gatewayIndex',
          meta: {
            title: '网关列表',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/gatewaySettingManage/gatewayIndex.vue'
            ], resolve)
        },
        {
          path: '/gatewaySettingManage/gatewayDetail',
          name: 'gatewayDetail',
          meta: {
            title: '网关详情',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/gatewaySettingManage/gatewayDetail.vue'
            ], resolve)
        },
        {
          path: '/operateCenterManage/operateDashboard',
          name: 'operateDashboard',
          meta: {
            title: '运营仪表盘',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/operateDashboard.vue'
            ], resolve)
        },
        {
          path: '/operateCenterManage/dashboardDetail',
          name: 'dashboardDetail',
          meta: {
            title: '编辑仪表盘',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/dashboardDetail.vue'
            ], resolve)
        },
        {
          path: '/camera/cameraIndex/:id',
          name: 'cameraIndex',
          meta: {
            title: '设备监控',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/camera/cameraIndex.vue'], resolve)
        },
        {
          path: '/operateCenterManage/reportDashboard',
          name: 'reportDashboard',
          meta: {
            title: '地图监控',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/reportDashboard.vue'
            ], resolve)
        },
        {
          path: '/preventionProjectManage/preventionProjectGroupIndex',
          name: 'preventionProjectGroupIndex',
          meta: {
            title: '预防项目管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/preventionProjectManage/preventionProjectGroupIndex.vue'
            ], resolve)
        },
        {
          path: '/preventionProjectManage/addPreventionProjectGroup',
          name: 'addPreventionProjectGroup',
          meta: {
            title: '新增预防项目分组',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/preventionProjectManage/addPreventionProjectGroup.vue'
            ], resolve)
        },
        {
          path: '/preventionProjectManage/viewPreventionGroup',
          name: 'viewPreventionGroup',
          meta: {
            title: '查看预防项目分组',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/preventionProjectManage/viewPreventionGroup.vue'
            ], resolve)
        },
        {
          path: '/preventionProjectManage/editPreventionGroup',
          name: 'editPreventionGroup',
          meta: {
            title: '编辑预防项目分组',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/preventionProjectManage/editPreventionGroup.vue'
            ], resolve)
        },
        {
          path: '/preventionProjectManage/preventionIndex',
          name: 'preventionIndex',
          meta: {
            title: '预防维护项目管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/preventionProjectManage/preventionIndex.vue'
            ], resolve)
        },
        {
          path: '/task/configurationIndex',
          name: 'configurationIndex',
          meta: {
            title: '任务配置',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/preventionProjectManage/configurationIndex.vue'], resolve)
        },
        {
          path: '/operateCenterManage/ezvizEquipmentIndex',
          name: 'ezvizEquipmentIndex',
          meta: {
            title: '萤石云监控管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/ezvizEquipmentManager/ezvizEquipmentIndex.vue'
            ], resolve)
        },
        {
          path: '/operateCenterManage/ezvizEquipmentConfig',
          name: 'ezvizEquipmentConfig',
          meta: {
            title: '监控项目配置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/ezvizEquipmentManager/ezvizEquipmentConfig.vue'
            ], resolve)
        },
        {
          path: '/operateCenterManage/ezvizList',
          name: 'ezvizList',
          meta: {
            title: '萤石云监控列表',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/ezvizEquipmentManager/ezvizList.vue'
            ], resolve)
        },
        {
          path: '/operateCenterManage/thumbnailMonitor',
          name: 'thumbnailMonitor',
          meta: {
            title: '集中监控',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/thumbnailMonitor.vue'
            ], resolve)
        },
        {
          path: '/operateCenterManage/analysisReportView',
          name: 'analysisReportView',
          meta: {
            title: '报表视图',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/analysisReports/analysisReportView.vue'
            ], resolve)
        },
        {
          path: '/operateCenterManage/screenMonitor',
          name: 'screenMonitor',
          meta: {
            title: '大屏监控',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/screenMonitor.vue'
            ], resolve)
        },
        {
          path: '/operateCenterManage/screenView',
          name: 'screenView',
          meta: {
            title: '可视化大屏',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/screenView.vue'
            ], resolve)
        },
        {
          path: '/operateCenterManage/screenDashboard',
          name: 'screenDashboard',
          meta: {
            title: '大屏仪表盘',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/screenDashboard.vue'
            ], resolve)
        },
        {
          path: '/operateCenterManage/screenMonitorDataSet',
          name: 'screenMonitorDataSet',
          meta: {
            title: '大屏数据配置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/operateCenterManage/screenMonitorDataSet.vue'
            ], resolve)
        },
        {
          path: '/resistanceManage/resistanceIndex',
          name: 'resistanceIndex',
          meta: {
            title: '设备阻力数据分析',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/resistanceManage/resistanceIndex.vue'
            ], resolve)
        },
        {
          path:
            '/equipmentCenter/equipmentDashboardManage/equipmentVariableGroup',
          name: 'equipmentVariableGroup',
          meta: {
            title: '变量分组管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/equipmentCenter/equipmentDashboardManage/equipmentVariableGroup.vue'
            ], resolve)
        },
        // {
        //   path: '/operateCenterManage/test',
        //   name: 'screenMonitortest',
        //   meta: {
        //     title: "测试地图",
        //     keepAlive: false
        //   },
        //   component: resolve => require(['@/views/corp/operateCenterManage/test.vue'], resolve)
        // },
        {
          path: '/autoWaterDateRecord/autoWaterDateManageIndex',
          name: 'autoWaterDateManageIndex',
          meta: {
            title: '自动抄表变量设置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/autoWaterDateRecord/autoWaterDateManageIndex.vue'
            ], resolve)
        },
        {
          path: '/autoWaterDateRecord/resultWaterAmountIndex',
          name: 'resultWaterAmountIndex',
          meta: {
            title: '设备水量自动统计',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/autoWaterDateRecord/resultWaterAmount.vue'
            ], resolve)
        },
        {
          path: '/autoWaterDateRecord/resultElectricityAmount',
          name: 'resultElectricityAmount',
          meta: {
            title: '设备电量自动统计',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/autoWaterDateRecord/resultElectricityAmount.vue'
            ], resolve)
        },
        {
          path: '/autoWaterDateRecord/waterInfoPushIndex',
          name: 'waterInfoPushIndex',
          meta: {
            title: '产能数据推送设置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/autoWaterDateRecord/waterInfoPushIndex.vue'
            ], resolve)
        },
        {
          path: '/autoWaterDateRecord/dataListeningInfoPushIndex',
          name: 'dataListeningInfoPushIndex',
          meta: {
            title: '数据监控推送设置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/autoWaterDateRecord/dataListeningInfoPushIndex.vue'
            ], resolve)
        },
        {
          path: '/autoWaterDateRecord/dynamicCalenderIndex',
          name: 'dynamicCalenderIndex',
          meta: {
            title: '动态产能日历',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/autoWaterDateRecord/dynamicCalenderIndex.vue'
            ], resolve)
        },
        {
          path: '/role/roleIndex',
          name: 'roleIndex',
          meta: {
            title: '角色管理',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/role/roleIndex.vue'], resolve)
        },
        {
          path: '/data/authorityIndex',
          name: 'authorityIndex',
          meta: {
            title: '数据权限',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/systemManage/authorityIndex.vue'], resolve)
        },
        {
          path: '/data/addDeviceauthority',
          name: 'addDeviceauthority',
          meta: {
            title: '新增设备权限',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/systemManage/authorityModel.vue'], resolve)
        },
        {
          path: '/data/authorityGroupIndex',
          name: 'authorityGroupIndex',
          meta: {
            title: '设备分组权限',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/systemManage/authorityGroup.vue'], resolve)
        },
        {
          path: '/data/addauthorityGroupModel',
          name: 'addauthorityGroupModel',
          meta: {
            title: '新增设备分组权限',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/systemManage/addauthorityGroupModel.vue'
            ], resolve)
        },
        {
          path: '/data/editauthorityGroupModel',
          name: 'editauthorityGroupModel',
          meta: {
            title: '编辑设备分组权限',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/systemManage/editauthorityGroupModel.vue'
            ], resolve)
        },
        {
          path: '/sys/loginLogIndex',
          name: 'loginLogIndex',
          meta: {
            title: '登录日志',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/systemManage/loginLogIndex.vue'], resolve)
        },
        {
          path: '/sys/thirdSysIndex',
          name: 'thirdSysIndex',
          meta: {
            title: '第三方平台',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/systemManage/thirdSysIndex.vue'], resolve)
        },
        {
          path: '/user/userIndex',
          name: 'userIndex',
          meta: {
            title: '用户列表',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/user/userIndex.vue'], resolve)
        },
        {
          path: '/user/changePassword',
          name: 'changePassword',
          meta: {
            title: '修改密码',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/user/changePassword.vue'], resolve)
        },
        {
          path: '/organizationManage/departmentIndex',
          name: 'departmentIndex',
          meta: {
            title: '部门列表',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/organizationManage/departmentIndex.vue'
            ], resolve)
        },
        {
          path: '/partFolder/partFolderIndex',
          name: 'partFolderIndex',
          meta: {
            title: '物料文档管理',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/partFolder/partFolderIndex.vue'], resolve)
        },
        {
          path: '/approval/approvalIndex',
          name: 'approvalIndex',
          meta: {
            title: '审批管理',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/approval/approvalIndex.vue'], resolve)
        },
        {
          path: '/approvalManage/approvalList',
          name: 'approvalList',
          meta: {
            title: '审批列表',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/approvalManage/approvalList.vue'], resolve)
        },
        {
          path: '/approvalManage/addApproval',
          name: 'addApproval',
          meta: {
            title: '新增审批',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/approvalManage/addApproval.vue'], resolve)
        },
        {
          path: '/approvalManage/workflowConnection',
          name: 'workflowConnection',
          meta: {
            title: '工作流关系设置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/approvalManage/workflowConnection.vue'
            ], resolve)
        },
        {
          path: '/approvalManage/myApproval',
          name: 'myApproval',
          meta: {
            title: '我的审批',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/approvalManage/myApproval.vue'], resolve)
        },
        {
          path: '/approvalManage/waitApproval',
          name: 'waitApproval',
          meta: {
            title: '待审批',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/approvalManage/waitApproval.vue'], resolve)
        },
        {
          path: '/approvalManage/completeApproval',
          name: 'completeApproval',
          meta: {
            title: '已处理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/approvalManage/completeApproval.vue'
            ], resolve)
        },
        {
          path: '/approvalManage/CCMyApproval',
          name: 'CCMyApproval',
          meta: {
            title: '抄送我的',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/approvalManage/CCMyApproval.vue'], resolve)
        },
        {
          path: '/repairManage/repairIndex',
          name: 'repairIndex',
          meta: {
            title: '报修管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/repairManage/repairIndex.vue'
            ], resolve)
        },
        {
          path: '/repairManage/addRepair',
          name: 'addRepair',
          meta: {
            title: '报修单添加',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/repairManage/addRepair.vue'
            ], resolve)
        },
        {
          path: '/repairManage/editRepair',
          name: 'editRepair',
          meta: {
            title: '报修单编辑',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/repairManage/editRepair.vue'
            ], resolve)
        },
        {
          path: '/repairManage/viewRepair',
          name: 'viewRepair',
          meta: {
            title: '报修单详情',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/repairManage/viewRepair.vue'
            ], resolve)
        },
        {
          path: '/repairManage/repairReport',
          name: 'repairReport',
          meta: {
            title: '服务报告',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/repairManage/repairReport.vue'
            ], resolve)
        },
        {
          path: '/repairManage/repairReportDetail',
          name: 'repairReportDetail',
          meta: {
            title: '服务报告',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/repairManage/repairReportDetail.vue'
            ], resolve)
        },
        {
          path: '/checkProjectStorageManage/checkProjectStorageIndex',
          name: 'checkProjectStorageIndex',
          meta: {
            title: '点检项目列表',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/checkProjectStorageManage/checkProjectStorageIndex.vue'
            ], resolve)
        },
        {
          path: '/checkProjectStorageManage/addCheckGroup',
          name: 'addCheckGroup',
          meta: {
            title: '新增点检项目分组',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/checkProjectStorageManage/addCheckGroup.vue'
            ], resolve)
        },
        {
          path: '/checkProjectStorageManage/editCheckGroup',
          name: 'editCheckGroup',
          meta: {
            title: '编辑点检项目分组',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/checkProjectStorageManage/editCheckGroup.vue'
            ], resolve)
        },
        {
          path: '/checkProjectStorageManage/viewCheckGroup',
          name: 'viewCheckGroup',
          meta: {
            title: '查看点检项目分组',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/checkProjectStorageManage/viewCheckGroup.vue'
            ], resolve)
        },
        {
          path: '/checkRecordManage/checkRecordIndex',
          name: 'checkRecordIndex',
          meta: {
            title: '点检记录',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/checkRecordManage/checkRecordIndex.vue'
            ], resolve)
        },
        {
          path: '/checkRecordManage/addCheckRecord',
          name: 'addCheckRecord',
          meta: {
            title: '新增点检记录',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/checkRecordManage/addCheckRecord.vue'
            ], resolve)
        },
        {
          path: '/checkRecordManage/editCheckRecord',
          name: 'editCheckRecord',
          meta: {
            title: '编辑点检记录',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/checkRecordManage/editCheckRecord.vue'
            ], resolve)
        },
        {
          path: '/checkRecordManage/viewCheckRecord',
          name: 'viewCheckRecord',
          meta: {
            title: '查看点检记录',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/checkRecordManage/viewCheckRecord.vue'
            ], resolve)
        },
        {
          path: '/checkRecordManage/checkConfig',
          name: 'checkConfig',
          meta: {
            title: '点检配置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/checkRecordManage/checkConfig.vue'
            ], resolve)
        },
        {
          path: '/inspectionRecordManage/inspectionRecordIndex',
          name: 'inspectionRecordIndex',
          meta: {
            title: '巡检记录',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/inspectionRecordManage/inspectionRecordIndex.vue'
            ], resolve)
        },
        {
          path: '/inspectionRecordManage/addInspectionRecord',
          name: 'addInspectionRecord',
          meta: {
            title: '新增巡检记录',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/inspectionRecordManage/addInspectionRecord.vue'
            ], resolve)
        },
        {
          path: '/inspectionRecordManage/editInspectionRecord',
          name: 'editInspectionRecord',
          meta: {
            title: '编辑巡检记录',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/inspectionRecordManage/editInspectionRecord.vue'
            ], resolve)
        },
        {
          path: '/inspectionRecordManage/viewInspectionRecord',
          name: 'viewInspectionRecord',
          meta: {
            title: '查看巡检记录',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/inspectionRecordManage/viewInspectionRecord.vue'
            ], resolve)
        },
        {
          path: '/inspectionRecordManage/inspectionConfig',
          name: 'inspectionConfig',
          meta: {
            title: '巡检配置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/inspectionRecordManage/inspectionConfig.vue'
            ], resolve)
        },
        {
          path: '/inspectionProjectManage/inspectionProjectIndex',
          name: 'inspectionProjectIndex',
          meta: {
            title: '巡检标准',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/inspectionProjectManage/inspectionProjectIndex.vue'
            ], resolve)
        },
        {
          path: '/inspectionProjectManage/addInspectionProject',
          name: 'addInspectionProject',
          meta: {
            title: '新增巡检标准',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/inspectionProjectManage/addInspectionProject.vue'
            ], resolve)
        },
        {
          path: '/inspectionProjectManage/editInspectionProject',
          name: 'editInspectionProject',
          meta: {
            title: '编辑巡检标准',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/inspectionProjectManage/editInspectionProject.vue'
            ], resolve)
        },
        {
          path: '/inspectionProjectManage/viewInspectionProject',
          name: 'viewInspectionProject',
          meta: {
            title: '查看巡检标准',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/inspectionProjectManage/viewInspectionProject.vue'
            ], resolve)
        },
        {
          path: '/myWorkOrderManage/mobileLogisticsInfo',
          name: 'mobileLogisticsInfo1',
          meta: {
            title: '查看我的工单',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/repairManage/mobileLogisticsInfo.vue'
            ], resolve)
        },
        {
          path: '/myWorkOrderManage/myWorkOrderList',
          name: 'myWorkOrderList',
          meta: {
            title: '查看我的工单',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/afterSaleManage/myWorkOrderManage/myWorkOrderList.vue'
            ], resolve)
        },
        {
          path: '/customerManage/customerIndex',
          name: 'customerIndex',
          meta: {
            title: '客户列表',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/customerManage/customerIndex.vue'], resolve)
        },
        {
          path: '/customerManage/customerSatisfaction',
          name: 'customerSatisfaction',
          meta: {
            title: '客户满意度',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/customerManage/satisfaction/customerSatisfaction.vue'
            ], resolve)
        },
        {
          path: '/customerManage/customerSatisfactionView',
          name: 'customerSatisfactionView',
          meta: {
            title: '客户满意度的统计分析',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/customerManage/satisfaction/customerSatisfactionView.vue'
            ], resolve)
        },
        {
          path: '/customerManage/customerSatisfactionDetail',
          name: 'customerSatisfactionDetail',
          meta: {
            title: '客户满意度详情',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/customerManage/satisfaction/customerSatisfactionDetail.vue'
            ], resolve)
        },
        {
          path: '/customerManage/customerSatisfactionAdd',
          name: 'customerSatisfactionAdd',
          meta: {
            title: '添加客户满意度',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/customerManage/satisfaction/customerSatisfactionAdd.vue'
            ], resolve)
        },
        {
          path: '/customerManage/customerEquipmentIndex',
          name: 'customerEquipmentIndex',
          meta: {
            title: '客户设备列表',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/customerManage/customerEquipmentIndex.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/reportOverview',
          name: 'reportOverview',
          meta: {
            title: '报表总览',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/reportOverviews/reportOverview.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/dataAnalysis/waterAnalysis',
          name: 'waterAnalysis',
          meta: {
            title: '水质分析',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/dataAnalysis/waterAnalysis.vue'
            ], resolve)
        },
        {
          path: '/autoWaterDateRecord/rawWaterDataRecordIndex',
          name: 'rawWaterDataRecordIndex',
          meta: {
            title: '水质检测报告',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/autoWaterDateRecord/rawWaterDataRecordIndex.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/dataAnalysis/conductanceOverview',
          name: 'conductanceOverview',
          meta: {
            title: '实时电导监控',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/dataAnalysis/conductance/conductanceOverview.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/dataAnalysis/conductanceSetting',
          name: 'conductanceSetting',
          meta: {
            title: '电导监控配置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/dataAnalysis/conductance/conductanceSetting.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/dataAnalysis/alarmRecord',
          name: 'alarmRecord',
          meta: {
            title: '电导报警记录',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/dataAnalysis/conductance/alarmRecord.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/dataAnalysis/conductanceMap',
          name: 'conductanceMap',
          meta: {
            title: '电导监控地图',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/dataAnalysis/conductance/conductanceMap.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/configManage/meterCodeManage',
          name: 'meterCodeManage',
          meta: {
            title: '水量表码管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/configManage/meterCodeManage.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/equipmentRecord/effectiveValueManage',
          name: 'effectiveValueManage',
          meta: {
            title: '设备历史数据有效值配置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/configManage/effectiveValue/index.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/warnSettingList',
          name: 'warnSettingList',
          meta: {
            title: '预警设置列表',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/warnSettingList.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/uploaderDownLoadCenter',
          name: 'uploaderDownLoadCenter',
          meta: {
            title: '上传/下载中心',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/uploaderDownLoadCenter.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/remindSettingIndex',
          name: 'remindSettingIndex',
          meta: {
            title: '发送时间配置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/remindSetting/remindSettingIndex.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/lockDataIndex',
          name: 'lockDataIndex',
          meta: {
            title: '报表数据锁定',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/lockData/lockDataIndex.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/equipWaterStatisticsList',
          name: 'equipWaterStatisticsList',
          meta: {
            title: '设备水量统计管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/equipWaterStatisticsList.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/equipWaterStatistic',
          name: 'equipWaterStatistic',
          meta: {
            title: '设备水量统计报表',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/equipWaterStatistic.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/equipElectricityStatisticList',
          name: 'equipElectricityStatisticList',
          meta: {
            title: '设备电量统计管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/equipElectricityStatisticList.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/sulphateOutStatisticList',
          name: 'sulphateOutStatisticList',
          meta: {
            title: '硫酸出库统计管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/sulphateOutStatisticList.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/sulphateStorageStatisticList',
          name: 'sulphateStorageStatisticList',
          meta: {
            title: '硫酸入库统计管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/sulphateStorageStatisticList.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/materialStatisticList',
          name: 'materialStatisticList',
          meta: {
            title: '物料统计管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/materialStatisticList.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/brokenRecordStatisticList',
          name: 'brokenRecordStatisticList',
          meta: {
            title: '故障记录统计管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/brokenRecordStatisticList.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/downtimeRecordStatisticList',
          name: 'downtimeRecordStatisticList',
          meta: {
            title: '停机记录统计管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/downtimeRecordStatisticList.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/serviceReportStatistic',
          name: 'serviceReportStatistic',
          meta: {
            title: '服务报告统计报表',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/serviceReportStatistic.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/repairOrderStatistic',
          name: 'repairOrderStatistic',
          meta: {
            title: '报修单统计报表',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/repairOrderStatistic.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/dropDownListSet',
          name: 'dropDownListSet',
          meta: {
            title: '统计报表下拉配置',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/dropDownListSet.vue'
            ], resolve)
        },
        {
          path: '/analysisCenterManage/downtimeReasonIndex',
          name: 'downtimeReasonIndex',
          meta: {
            title: '停机原因管理',
            keepAlive: false
          },
          component: resolve =>
            require([
              '@/views/corp/analysisCenterManage/downtimeReasonIndex.vue'
            ], resolve)
        },
        {
          path: '/equipmentAccessoryReplaceManager/equipAccessoryReplaceRecordList',
          name: 'equipAccessoryReplaceRecordList',
          meta: {
            title: '设备配件更换记录管理',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/equipmentCenter/equipmentAccessoryReplaceManager/equipAccessoryReplaceRecordList.vue'], resolve)
        },
        {
          path: '/messageManage/messageIndex',
          name: 'messageIndex',
          meta: {
            title: '消息中心',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/messageManage/messageIndex.vue'], resolve)
        },
        {
          path: '/taskSetManage/taskSettingList',
          name: 'taskSettingList',
          meta: {
            title: '任务设置',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/taskSetManage/taskSettingList.vue'], resolve)
        },
        ...MaterialManageRoutes,
        {
          path: '/districtManage/districtIndex',
          name: 'districtIndex',
          meta: {
            title: '区域管理',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/districtManage/districtIndex.vue'], resolve)
        },
        {
          path: '/projectCenter/projectIndex',
          name: 'projectIndex',
          meta: {
            title: '项目管理',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/projectCenter/projectManage/projectIndex.vue'
            ], resolve)
        },
        {
          path: '/projectCenter/map',
          name: 'projectMap',
          meta: {
            title: '项目地图',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/projectCenter/projectManage/projectMap.vue'
            ], resolve)
        },
        {
          path: '/projectCenter/groupLocalMap',
          name: 'projectGroupLocalMap',
          meta: {
            title: '项目人员点位分布',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/projectCenter/projectManage/projectGroupLocalMap.vue'
            ], resolve)
        },
        {
          path: '/user/projectUserLocalRecord',
          name: 'projectUserLocalRecord',
          meta: {
            title: '项目人员点位分布',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/user/userLocalRecordIndex.vue'
            ], resolve)
        },
        {
          path: '/projectCenter/addProject',
          name: 'addProject',
          meta: {
            title: '新增项目',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/projectCenter/projectManage/projectConfig.vue'
            ], resolve)
        },
        {
          path: '/projectCenter/editProject',
          name: 'editProject',
          meta: {
            title: '修改项目',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/projectCenter/projectManage/projectConfig.vue'
            ], resolve)
        },
        {
          path: '/projectCenter/projectView',
          name: 'projectView',
          meta: {
            title: '项目详情',
            keepAlive: true
          },
          component: resolve =>
            require([
              '@/views/corp/projectCenter/projectManage/projectView.vue'
            ], resolve)
        },
        {
          path: '/sys/feedbackUpload',
          name: 'feedbackUpload',
          meta: {
            title: '提交反馈',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/feedbackManage/feedbackUpload.vue'], resolve)
        },
        {
          path: '/sys/feedbackIndex',
          name: 'feedbackIndex',
          meta: {
            title: '反馈记录',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/feedbackManage/feedbackIndex.vue'], resolve)
        },
        {
          path: '/sys/feedbackDetail',
          name: 'feedbackDetail',
          meta: {
            title: '反馈详情',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/corp/feedbackManage/feedbackDetail.vue'], resolve)
        }
      ].concat(otherRouter)
    },
    {
      path: '/adminLogin',
      name: 'adminLogin',
      component: resolve => require(['@/views/adminLogin.vue'], resolve)
    },
    {
      path: '/admin',
      name: 'adminIndex',
      component: resolve => require(['@/views/adminIndex.vue'], resolve),
      children: [
        {
          path: '/admin',
          name: '',
          meta: {
            title: '首页',
            keepAlive: false
          },
          component: resolve => require(['@/views/adminTemplate.vue'], resolve)
        },
        {
          path: '/admin/log/index',
          name: 'logIndex',
          meta: {
            title: '日志管理',
            keepAlive: false
          },
          component: resolve => require(['@/views/admin/logIndex.vue'], resolve)
        },
        {
          path: '/admin/dictionary/index',
          name: 'dictionaryIndex',
          meta: {
            title: '系统字典',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/admin/dictionaryIndex.vue'], resolve)
        },
        {
          path: '/admin/monitor/index',
          name: 'monitorIndex',
          meta: {
            title: '系统监控',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/admin/monitorIndex.vue'], resolve)
        },
        {
          path: '/admin/function/authList',
          name: 'authList',
          meta: {
            title: '权限列表',
            keepAlive: false
          },
          component: resolve => require(['@/views/admin/authList.vue'], resolve)
        },
        {
          path: '/admin/function/index',
          name: 'functionIndex',
          meta: {
            title: '功能操作列表',
            keepAlive: false
          },
          component: resolve =>
            require(['@/views/admin/functionIndex.vue'], resolve)
        },
        {
          path: '/admin/function/syncList',
          name: 'syncList',
          meta: {
            title: '功能操作同步',
            keepAlive: false
          },
          component: resolve => require(['@/views/admin/syncList.vue'], resolve)
        },
        {
          path: '/admin/function/editAuth',
          name: 'editAuth',
          meta: {
            title: '修改权限',
            keepAlive: false
          },
          component: resolve => require(['@/views/admin/editAuth.vue'], resolve)
        }
      ]
    },

    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/videoSurveillance',
          name: 'videoSurveillance',
          meta: {title: '视频监控', keepAlive: false},
          component: () =>
            import(
              /* webpackChunkName: "videoSurveillance" */ '../views/videoSurveillance/index.vue'
              )
        },

        {
          path: '/AIBoxConfig',
          name: 'AIBoxConfig',
          meta: {title: 'AI盒子配置', keepAlive: false},
          component: () =>
            import(
              /* webpackChunkName: "AIBoxConfig" */ '../views/AIBoxConfig/index.vue'
              )
        },
        {
          path: '/strategyConfig',
          name: 'strategyConfig',
          meta: {title: '策略配置', keepAlive: false},
          component: () =>
            import(
              /* webpackChunkName: "strategyConfig" */ '../views/strategyConfig/index.vue'
              )
        },
        {
          path: '/alarmData',
          name: 'alarmData',
          meta: {title: '告警数据', keepAlive: false},
          component: () =>
            import(
              /* webpackChunkName: "alarmData" */ '../views/alarmData/index.vue'
              )
        },
        {
          path: '/alarmStat',
          name: 'alarmStat',
          meta: {title: '告警统计', keepAlive: false},
          component: () =>
            import(
              /* webpackChunkName: "alarmStat" */ '../views/alarmStat/index.vue'
              )
        },
        {
          path: '/factoryConfig',
          name: 'factoryConfig',
          meta: {title: '厂区配置', keepAlive: false},
          component: () =>
            import(
              /* webpackChunkName: "factoryConfig" */ '../views/factoryConfig/index.vue'
              )
        }
      ]
    },
    // 钉钉专属页面
    {
      path: "/materialManage/material-transfer/abnormalForm-dingTalk",
      name: "materialTransferDDAbnormalForm",
      meta: {
        title: "调拨异常处理",
        keepAlive: false
      },
      component: resolve =>
        require([
          "@/views/corp/materialManage/material-transfer/abnormalForm.vue"
        ], resolve)
    },
    {
      path: "/materialManage/stock-transfer/abnormalForm-dingTalk",
      name: "stockTransferDDAbnormalForm",
      meta: {
        title: "转储异常处理",
        keepAlive: false
      },
      component: resolve =>
        require([
          "@/views/corp/materialManage/stock-transfer/abnormalForm.vue"
        ], resolve)
    },
    {
      path: '/materialManage/purchase-receive/abnormalForm-dingTalk',
      meta: { title: '采购收货异常处理' },
      component: () => import('@/views/corp/materialManage/purchase-receive/handle-abnormal.vue')
    },
  ]
})
//直达路由（即需要直接访问的路由） 通过权限在这里配置
router.beforeEach((to, from, next) => {
  sessionStorage.setItem('beforePath', from.fullPath)
  // sessionStorage.setItem('wxUserInfo',JSON.stringify("{wcId:'1564165846', name:'2222'}"))
  // console.log(sessionStorage.getItem('wxUserInfo'))
  if(sessionStorage.getItem('wxUserInfo')){
    console.log("存在")
  }
  //针对手机端
  if (
    to.path.includes('abnormalForm-dingTalk') || //钉钉打开的异常处理页面
    to.path.includes('troubleshoot') || //打开故障查询页面
    (to.fullPath.includes('addRepairCustomer') && sessionStorage.getItem('wxUserInfo')) ||  //客户需求登记页面
    (to.fullPath.includes('viewAndEditRepairCustomer') && sessionStorage.getItem('wxUserInfo')) ||  //客户需求登记页面
    (to.fullPath.includes('repairCustomerList') && sessionStorage.getItem('wxUserInfo')) ||  //客户需求登记页面
    (to.fullPath.includes('repairCustomerIndex') ) ||  //客户需求列表页面
    (to.fullPath.includes('mobileAfterSaleChatLLM') ) ||  //移动端对接内网的llm服务
    to.fullPath.indexOf('/login') > -1 ||
    to.fullPath === '/adminLogin' ||
    to.path === '/mobile/login' ||
    to.path === '/mobile/dingLogin' ||
    to.path === '/mobile/viewAndEditRepairCustomer' ||　//客户报修接单页
    to.path === '/wechat/auth' ||
    to.path === '/mobile/mobileCustomerSatisfactionEdit' ||
    to.path === '/dingTalk/auth' ||
    to.path === '/customerManage/customerSatisfactionEdit' ||
    to.path === '/mobile/errorMessageDetail'

  ) {
    console.log('next---前>>>')
    next()
    console.log('next---后>>>')
    return false
  }
  if (!window.sessionStorage) {
    alert('浏览器不支持sessionStorage')
  } else {
    if (/^\/mobile/.test(to.path)) {
      if (sessionStorage.token != null && sessionStorage.token !== '') {
        next()
        return ''
      } else {
        if (sessionStorage.loginType === 'dingLogin') {
          next({
            path: '/mobile/dingLogin'
          })
        } else {
          next({
            path: '/mobile/login'
          })
        }
        alert('对不起，您尚未登录，请先登录！')
        return ''
      }
    }
    // if (/^\/auth/.test(to.path)) {
    //   next({
    //     path: "/wechat/auth"
    //   });
    // }
    //针对电脑端
    //对客户需求登记路由进行免登录访问 ||to.path.includes('addRepairCustomer')
    if (to.path.includes('abnormalForm-dingTalk')||
    to.path.includes('addRepairCustomer')||
    ( sessionStorage.token != null && sessionStorage.token !== '')) {
      next()
      return ''
    } else {
      let userType = sessionStorage.userType
      if (userType === 'superAdmin') {
        next({
          path: '/adminLogin'
        })
        alert('对不起，您尚未登录，请先登录！')
        return ''
      } else if (userType === 'user') {
        next({
          path: '/login'
        })
        alert('对不起，您尚未登录，请先登录！')
        return ''
      } else {
        if (to.fullPath.indexOf('admin') > -1) {
          next({
            path: '/adminLogin'
          })
          alert('对不起，您尚未登录，请先登录！')
          return ''
        } else {
          next({
            path: '/login'
          })
          alert('对不起，您尚未登录，请先登录！')
          return ''
        }
      }
    }
  }
  next()
})

router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  console.log('路由错误')
  if (isChunkLoadFailed) {
    console.log('进入')
    router.replace(targetPath)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js